import { appConfig, formatDate, GoogleMapsLink } from '@ami/react/core';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { isAmiUserAuthorizedToViewQuoteGroups } from '../../../authorization/amiPermissions';
import QuoteView, { userType } from '../../../quotes/view/quoteView';
import DealerInvitationModal from '../../review/quote-details/DealerInvitationModal';

export default class QuoteInformationComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDealerInvitationModal: false,
      dealerInvitationSent: false
    };
  }

  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
  };

  getTypeUser = (user) => {
    if (user) {
      switch (user.type) {
        case userType.AMI:
          return appConfig.isManagementApp ? '' : ' (AMI)';
        case userType.Dealer:
          return appConfig.isManagementApp ? ' (Dealer)' : '';
        default:
          break;
      }
    }
    return '';
  };

  invitationSent = () => {
    this.toggleDealerInvitationModal(false);
    this.setState({ dealerInvitationSent: true });
  }

  toggleDealerInvitationModal = (show) => {
    this.setState({ showDealerInvitationModal: show });
  }

  render() {
    const { quote } = this.props;
    const { showDealerInvitationModal, dealerInvitationSent } = this.state;

    return (
      <div className="card mb-3 box-shadow quote-info flex-fill">
        <div className="card-body">
          <h6 className="card-title text-center">Quote Information</h6>
          <div className="row">
            <label className="col-sm-4">Created</label>
            <div className="col-sm-8">{formatDate(quote.date)}</div>
          </div>
          <div className="row">
            <label className="col-sm-4">Expires</label>
            <div className="col-sm-8">{formatDate(quote.expireDate)}</div>
          </div>
          <div className="row">
            <label className="col-sm-4">Created By</label>
            <div className="col-sm-8">
              {quote.createdBy.fullName + this.getTypeUser(quote.createdBy)}
            </div>
          </div>
          <div className="row">
            <label className="col-sm-4">Industry</label>
            <div className="col-sm-8">
              {quote.industryName || 'Not Specified'}
            </div>
          </div>
          {appConfig.isManagementApp && (
            <div className="row">
              <label className="col-sm-4">Price Zone</label>
              <div className="col-sm-8">
                <div>{quote.priceZoneName}</div>
              </div>
            </div>
          )}
          <div className="row">
            <label className="col-sm-4">Branch</label>
            <div className="col-sm-8">
              <div>{quote.dealerInformation.dealerBranchName}</div>
              <div>{quote.dealerInformation.dealerBranchAddress}</div>
            </div>
          </div>
          <div className="row">
            <label className="col-sm-4">Ship To</label>
            <div className="col-sm-8">
              {quote.customShippingLocation && (
                <Fragment>
                  <strong>Custom Location:</strong>
                  <br />
                  <GoogleMapsLink location={quote.customShippingLocation} />
                </Fragment>
              )}
              {!quote.customShippingLocation && (
                <span>{quote.dealerInformation.dealerBranchName}</span>
              )}
            </div>
          </div>
          <div className="row">
            <label className="col-sm-4">Contact</label>
            <div className="col-sm-8">
              <div>{quote.dealerInformation.dealerUserName}</div>
              {!quote.dealerInformation.isRegistered && appConfig.isManagementApp && (
                <div className="row row-cols-1">
                  <div className="col">
                    <div className="banner-container">
                      <div className="card-body alert alert-warning py-1 mb-0">
                        {!dealerInvitationSent && (
                          <div className="card-text">
                            <span>User is not registered for Blackbird</span>
                            <span>
                              <button type="button" className="btn btn-link ps-1 p-0 mb-1" onClick={() => this.toggleDealerInvitationModal(true)}>send invite</button>
                            </span>
                          </div>
                        )}

                        {dealerInvitationSent && (
                          <div className="card-text">
                            <span>Invitation sent</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {appConfig.isManagementApp && (
            <DealerInvitationModal
              dealerUserId={quote.dealerInformation.dealerUserId}
              dealerUserName={quote.dealerInformation.dealerUserName}
              onChanged={this.invitationSent}
              show={showDealerInvitationModal}
              onHide={() => this.toggleDealerInvitationModal(false)} />
          )}

          <div className="row">
            <label className="col-sm-4">Sales Person</label>
            <div className="col-sm-8">{quote.salesPersonName}</div>
          </div>
          <div className="row">
            <label className="col-sm-4">TM</label>
            <div className="col-sm-8">
              {quote.territoryManagerInformation.fullName}
            </div>
          </div>
          { quote.billingInstructions && (
            <div className="row">
              <label className="col-sm-4">Billing Instructions</label>
              <div className="col-sm-8 text-break-line">
                {quote.billingInstructions}
              </div>
            </div>
          )}
          { quote.shippingInstructions && (
            <div className="row">
              <label className="col-sm-4">Shipping Instructions</label>
              <div className="col-sm-8 text-break-line">
                {quote.shippingInstructions}
              </div>
            </div>
          )}
          <div className="row">
            <label className="col-sm-4">Notes</label>
            <div className="col-sm-8 text-break-line">
              {quote.notes || 'N/A'}
            </div>
          </div>
          {appConfig.isManagementApp && quote.privateNotes && (
            <div className="row">
              <label className="col-sm-4">Private Notes</label>
              <div className="col-sm-8 text-break-line">
                {quote.privateNotes || 'N/A'}
              </div>
            </div>
          )}
          {appConfig.isManagementApp && (
            <div className="row">
              <label className="col-sm-4">Quote Group</label>
              <div className="col-sm-8 text-break-line">
                {isAmiUserAuthorizedToViewQuoteGroups() ? (
                  quote.quoteGroupName ? (
                    <Link
                      target="_blank"
                      to={`/quote-groups/view/${quote.quoteGroupId}`}
                    >
                      {quote.quoteGroupName}
                    </Link>
                  ) : (
                    'N/A'
                  )
                ) : (
                  quote.quoteGroupName || 'N/A'
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
